<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="70%">
      <v-card>
        <v-card-title>Asignar Plataforma Moodle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p v-html="datamsg"></p>
          <v-combobox
            v-model="selected" 
            class="ma-2"
            :items="plataformas"
            item-text="name"
            label="Buscar"
            hint="Escriba y Seleccione La plataforma de Moodle"
            dense
            outlined
          >
          </v-combobox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" rounded v-if="selected" @click="assignPlataformaToPrograma"> <v-icon> mdi-plus</v-icon> Asignar Plataforma </v-btn>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialog"> Cerrar <v-icon> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import gql from 'graphql-tag';
import { mapState } from 'vuex';
export default {
  props: ['programa'],
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      selected: null,
      plataformas: [],
      search: '',
      dialog: false,
      isdevmode: false,
      datamsg:'',
    };
  },
  watch: {
    UNIDAD_NEGOCIO_ID() {
      this.plataformas = [];
      this.getDatosPlataformas();
    },
  },
  computed: {
    ...mapState({
      // programa: (state) => state.programa.value,
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },
  methods: {
    assignPlataformaToPrograma() {
      this.$root.$confirm.open('Asignar Plataforma', 'Estas seguro de asignar?', { color: 'orange' }).then((confirm) => {
        if (this.programa && this.selected && confirm) {
          const sql = gql`mutation{asignarPlataforma(input:{ programa_id: ${this.programa.id}, plataforma_id: ${this.selected.id} }){ok errors{message}} }`;
          // window.console.log('this.programa && this.selected && ', this.programa, this.selected, sql);
          this.$apollo
            .mutate({ mutation: sql })
            .then(({ data: { asignarPlataforma } }) => {
              if (asignarPlataforma.ok) {
                this.$root.$notify.show('ID Plataforma Asignado Exitosamente', { color: 'success' });
                this.programa.plataforma_id = this.selected.id;
                this.$emit('reloadGetPlataforma');
              } else {
                asignarPlataforma.errors.forEach((error) => this.$root.$notify.show('ERROR:' + error.message, { color: 'red' }));
              }
              this.dialog = false;
            })
            .catch((err) => this.$root.$notify.show(`ERROR: Asignar Plataforma ${err}`, { color: 'red' }));
        }
      });
    },
    getDatosPlataformas() {
      let xgql ="";
      if( this.isdevmode ) xgql = gql`query { getPlataformas { id nombre direccion unidad_negocio_id estado }}`;
      else xgql = gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`
      this.$apollo
        .query({
          query: xgql,
        })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas.map((item) => {
            item.name = item.nombre.toUpperCase() + '  --   ' + item.direccion;
            return item;
          });
        })
        .catch((err) => this.$root.$notify.show(`ERROR: getPlataformas(DialogAssignPla) ${err}`));
    },
    closeDialog() {
      this.dialog = false;
    },
    setPlataforma(p){ 
      this.datamsg = p?.nombre && p?.direccion ? `<b>Actual</b>: ${p.nombre} [${p.direccion}]` : 'No tiene Plataforma Asignada';
    }
  },
  mounted() {
    let apidev = process.env.VUE_APP_GRAPHQL;
    if( apidev.includes("apidev") ){ this.isdevmode = true; }
    this.getDatosPlataformas();
  },
};
</script>
